import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { removeBlank } from 'src/app/core/helpers';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class TestRoomService extends ApiService {
  public eventEmitter = new EventEmitter();
  public getTestRoom(param): Observable<any> {
    return this.request({
      path: 'test-rooms/',
      method: 'GET',
      query: removeBlank(param)
    });
  }

  public getDropdown(): Observable<any> {
    return this.request({
      path: 'test-rooms/dropdown',
      method: 'GET',
    });
  }

  public deleteTestRoom(id): Observable<any> {
    return this.request({
      path: `test-rooms/${id}`,
      method: 'DELETE'
    });
  }

  public updateTestRoom(data, id): Observable<any> {
    return this.request({
      path: `test-rooms/${id}`,
      method: 'PUT',
      body: data
    });
  }

  public create(data): Observable<any> {
    return this.request({
      path: 'test-rooms',
      method: 'POST',
      body: data
    });
  }

  public getTestRoomById(id): Observable<any> {
    return this.request({
      path: `test-rooms/${id}`,
      method: 'GET'
    });
  }

}
